/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable react/react-in-jsx-scope */

import {
  Books,
  ChartDonut, ChartPie, ClockCountdownIcon, Files,
  FlowArrow, FlowArrowIcon, Gear, PaintRoller, PlugsConnected,
  PuzzlePiece, Scroll, SealCheck, Shield, Sparkle,
  UserCircle,
  Wallet,
  WrenchIcon
} from '@phosphor-icons/react';

import { MenuItem, MenuItems } from 'components/organisms/Sidebar';
import { ROUTE_PATHS } from 'utils/constants';

const menuSidebar: MenuItem[] = [
  {
    descriptions: 'Agent',
    key: 'agent',
    title: 'Agent',
    path: ROUTE_PATHS.AGENT,
    icon: {
      active: <Sparkle size={20} className="o-sidebar_icon-active" />,
      inactive: <Sparkle size={20} className="o-sidebar_icon" />,
    },
  },
  {
    descriptions: 'Usage analytics',
    key: 'usage',
    path: ROUTE_PATHS.MONITOR_DASHBOARD,
    title: 'Usage analytics',
    icon: {
      active: <ChartDonut size={20} className="o-sidebar_icon-active" />,
      inactive: <ChartDonut size={20} className="o-sidebar_icon" />,
    },
    childrens: [ROUTE_PATHS.CREATE_AGENT, ROUTE_PATHS.EDIT_AGENT],
  },
  // {
  //   descriptions: 'Customers',
  //   key: 'customer_management',
  //   path: ROUTE_PATHS.CUSTOMER_ACCOUNTS,
  //   icon: {
  //     active: <Icon iconName="customersActive" size="24" />,
  //     inactive: <Icon iconName="customers" size="24" />,
  //   },
  //   childrens: [ROUTE_PATHS.CREATE_CUSTOMER_ACCOUNTS],
  // },
  // {
  //   descriptions: 'Data Tags',
  //   key: 'data_tag_management',
  //   path: ROUTE_PATHS.DATATAG,
  //   icon: {
  //     active: <Icon iconName="tagsActive" size="24" />,
  //     inactive: <Icon iconName="tags" size="24" />,
  //   },
  //   childrens: [],
  // },
  // {
  //   descriptions: 'Billing & Usage',
  //   key: 'overview',
  //   path: ROUTE_PATHS.OVER_VIEW,
  //   icon: {
  //     active: <Icon iconName="walletActive" size="24" />,
  //     inactive: <Icon iconName="wallet" size="24" />,
  //   },
  //   childrens: [],
  // },
  // {
  //   descriptions: 'Email & SMS Settings',
  //   key: 'provider',
  //   path: ROUTE_PATHS.PROVIDER,
  //   icon: {
  //     active: <Icon iconName="emailActive" size="24" />,
  //     inactive: <Icon iconName="email" size="24" />,
  //   },
  //   childrens: [],
  // },
];

const menuSidebarExpried: MenuItem[] = [
  {
    key: 'dashboard',
    title: 'Usage analytics',
    descriptions: 'Usage analytics',
    path: ROUTE_PATHS.MONITOR_DASHBOARD,
    icon: {
      active: <ChartDonut size={20} className="o-sidebar_icon-active" />,
      inactive: <ChartDonut size={20} className="o-sidebar_icon" />,
    },
  }
];

const menuSidebarInactive: MenuItem[] = [
  {
    key: 'dashboard',
    title: 'Usage analytics',
    descriptions: 'Usage analytics',
    path: ROUTE_PATHS.PLAN_INACTIVE,
    icon: {
      active: <ChartDonut size={20} className="o-sidebar_icon-active" />,
      inactive: <ChartDonut size={20} className="o-sidebar_icon" />,
    },
  }
];

const menuSidebarAccount = (
  blogSlug?: string,
  isExpiredPlan?: boolean,
  isInactivePlan?: boolean
): MenuItems[] => {
  const isRestrictedPlan = !!isExpiredPlan || !!isInactivePlan;

  if (isRestrictedPlan) {
    return [
      {
        items: [
          {
            key: 'billing',
            title: 'Billing',
            path: ROUTE_PATHS.OVER_VIEW,
            icon: {
              active: <Wallet size={20} className="o-sidebar_icon-active" />,
              inactive: <Wallet size={20} className="o-sidebar_icon" />,
            },
          },
          {
            key: 'usage',
            title: 'Usage analytic',
            path: ROUTE_PATHS.MONITOR_DASHBOARD,
            icon: {
              active: <ChartDonut size={20} className="o-sidebar_icon-active" />,
              inactive: <ChartDonut size={20} className="o-sidebar_icon" />,
            },
          },
        ],
      },
    ];
  }

  // ✅ Full menu (active plan)
  return [
    {
      items: [
        {
          key: 'billing',
          title: 'Billing',
          path: ROUTE_PATHS.OVER_VIEW,
          icon: {
            active: <Wallet size={20} className="o-sidebar_icon-active" />,
            inactive: <Wallet size={20} className="o-sidebar_icon" />,
          },
        },
        {
          key: 'usage',
          title: 'Usage analytic',
          path: ROUTE_PATHS.MONITOR_DASHBOARD,
          icon: {
            active: <ChartDonut size={20} className="o-sidebar_icon-active" />,
            inactive: <ChartDonut size={20} className="o-sidebar_icon" />,
          },
        },
        {
          key: 'user-management',
          title: 'User management',
          path: ROUTE_PATHS.CUSTOMER_ACCOUNTS,
          icon: {
            active: <UserCircle size={20} className="o-sidebar_icon-active" />,
            inactive: <UserCircle size={20} className="o-sidebar_icon" />,
          },
        },
      ],
    },
    {
      items: [
        {
          key: 'extension',
          title: 'Extension',
          icon: {
            active: <PuzzlePiece size={20} className="o-sidebar_icon-active" />,
            inactive: <PuzzlePiece size={20} className="o-sidebar_icon" />,
          },
          items: [
            {
              key: 'email-sms',
              title: 'Email & sms template',
              path: ROUTE_PATHS.PROVIDER,
            },
          ],
        },
        {
          key: 'authorization',
          title: 'Authorization',
          icon: {
            active: <Shield size={20} className="o-sidebar_icon-active" />,
            inactive: <Shield size={20} className="o-sidebar_icon" />,
          },
          items: [
            { key: 'role', title: 'Role', path: ROUTE_PATHS.ROLE },
            { key: 'auth-user', title: 'User', path: ROUTE_PATHS.AUTH_USER },
          ],
        },
      ],
    },
    {
      items: [
        {
          key: 'docs',
          title: 'Docs & resources',
          path: blogSlug,
          icon: {
            active: <Files size={20} className="o-sidebar_icon-active" />,
            inactive: <Files size={20} className="o-sidebar_icon" />,
          },
          target: '_blank',
        },
        {
          key: 'terms',
          title: 'Terms and privacy',
          path: ROUTE_PATHS.TNC,
          icon: {
            active: <Scroll size={20} className="o-sidebar_icon-active" />,
            inactive: <Scroll size={20} className="o-sidebar_icon" />,
          },
          target: '_blank',
        },
      ],
    },
  ];
};

const menuInsideChatBot = (key: string | null, profile: any, feat?: string): MenuItems[] => [
  {
    components: 'Build',
    items: [
      {
        key: 'knowledge',
        icon: {
          active: <Books size={20} className="o-sidebar_icon-active" />,
          inactive: <Books size={20} className="o-sidebar_icon" />,
        },
        title: 'Knowledge',
        path: `/edit-agent?key=${key}&tab=knowledge&feat=${feat}`,
        descriptions: 'Manage knowledge base',
      },
      ...(feat === 'chatAgent'
        ? [
          {
            key: 'customize',
            icon: {
              active: <PaintRoller size={20} className="o-sidebar_icon-active" />,
              inactive: <PaintRoller size={20} className="o-sidebar_icon" />,
            },
            title: 'Customize',
            path: `/edit-agent?key=${key}&tab=customize&feat=${feat}`,
            descriptions: 'Customize agent appearance and behavior',
          },
        ]
        : []),
      // Conditional AI Actions tab
      ...(profile?.tierData.showAiAction && feat !== 'voiceAgent'
        ? [
          {
            key: 'action',
            icon: {
              active: <FlowArrow size={20} className="o-sidebar_icon-active" />,
              inactive: <FlowArrow size={20} className="o-sidebar_icon" />,
            },
            title: 'AI actions',
            path: `/edit-agent?key=${key}&tab=action&feat=${feat}`,
            descriptions: 'Advanced AI-powered actions',
          },
        ]
        : []),
      ...(feat === 'voiceAgent'
        ? [
          {
            key: 'workflow',
            icon: {
              active: <FlowArrowIcon size={20} className="o-sidebar_icon-active" />,
              inactive: <FlowArrowIcon size={20} className="o-sidebar_icon" />,
            },
            title: 'Workflow',
            path: `/edit-agent?key=${key}&tab=workflow&feat=${feat}`,
            descriptions: 'Manage workflows',
          },
        ]
        : []),

      {
        key: 'tool',
        title: 'Tool',
        path: `/edit-agent?key=${key}&tab=tool&feat=${feat}`,
        icon: {
          active: <WrenchIcon size={20} className="o-sidebar_icon-active" />,
          inactive: <WrenchIcon size={20} className="o-sidebar_icon" />,
        }
      },
    ]
  },
  {
    components: 'Integration',
    items: [
      {
        key: 'integration',
        icon: {
          active: <PlugsConnected size={20} className="o-sidebar_icon-active" />,
          inactive: <PlugsConnected size={20} className="o-sidebar_icon" />,
        },
        title: 'Integration',
        path: `/edit-agent?key=${key}&tab=integration&feat=${feat}`,
        descriptions: 'Connect with external platforms',
      }
    ]
  },
  {
    components: 'Analytic',
    items: [
      {
        key: 'monitorDashboard',
        icon: {
          active: <ChartPie size={20} className="o-sidebar_icon-active" />,
          inactive: <ChartPie size={20} className="o-sidebar_icon" />,
        },
        title: 'Monitor dashboard',
        path: `/edit-agent?key=${key}&tab=monitorDashboard&feat=${feat}`,
        descriptions: 'View performance metrics',
      },
      {
        key: 'evaluate',
        icon: {
          active: <SealCheck size={20} className="o-sidebar_icon-active" />,
          inactive: <SealCheck size={20} className="o-sidebar_icon" />,
        },
        title: 'Evaluate',
        path: `/edit-agent?key=${key}&tab=evaluate&feat=${feat}`,
        descriptions: 'Evaluate agent performance',
      },
      ...(feat === 'voiceAgent'
        ? [
          {
            key: 'callLog',
            icon: {
              active: <ClockCountdownIcon size={20} className="o-sidebar_icon-active" />,
              inactive: <ClockCountdownIcon size={20} className="o-sidebar_icon" />,
            },
            title: 'Call log',
            path: `/edit-agent?key=${key}&tab=callLog&feat=${feat}`,
            descriptions: 'Call log',
          },
        ]
        : []),
    ],

  },
  {
    components: 'Configuration',
    items: [
      {
        key: 'settings',
        icon: {
          active: <Gear size={20} className="o-sidebar_icon-active" />,
          inactive: <Gear size={20} className="o-sidebar_icon" />,
        },
        title: 'Settings',
        path: `/edit-agent?key=${key}&tab=settings&feat=${feat}`,
        descriptions: 'Settings agent performance',
      }
    ]
  }
];

export {
  menuSidebarExpried,
  menuSidebar,
  menuSidebarInactive,
  menuSidebarAccount,
  menuInsideChatBot
};
